// The Stripe success/cancel URLs are minted by /api and carry only the order id +
// {CHECKOUT_SESSION_ID} (the merged #801 contract), NOT the access token. To
// confirm the order against /api on the Success/Cancelled screens (never trusting
// the Stripe redirect alone), we stash the access token keyed by order id right
// after the authenticated summary resolves, refresh it before the Stripe
// hand-off, then read it back when Stripe redirects us home. It remains available
// after a successful status read so reloads can resolve the current registry
// return; explicit 404/410 responses clear it.
//
// sessionStorage (not localStorage): the token is a per-checkout credential; it
// should not outlive the tab/session.

const PREFIX = "tinkr.checkout.token.";

export function rememberTokenForOrder(orderId: string, token: string): void {
  try {
    window.sessionStorage.setItem(PREFIX + orderId, token);
  } catch {
    // Storage unavailable (private mode); post-Stripe screens show their
    // unconfirmed recovery state because they cannot authenticate the order.
  }
}

export function recallTokenForOrder(orderId: string): string | null {
  try {
    return window.sessionStorage.getItem(PREFIX + orderId);
  } catch {
    return null;
  }
}

export function forgetTokenForOrder(orderId: string): void {
  try {
    window.sessionStorage.removeItem(PREFIX + orderId);
  } catch {
    // no-op
  }
}
